import { render } from "./gbbd.vue?vue&type=template&id=63c3ffee&scoped=true&ts=true"
import script from "./gbbd.vue?vue&type=script&lang=ts"
export * from "./gbbd.vue?vue&type=script&lang=ts"

import "./gbbd.vue?vue&type=style&index=0&id=63c3ffee&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c3ffee"]])

export default __exports__